export default __webpack_public_path__ + "static/media/drag_video.a6883f70.png";